module.exports = __webpack_public_path__ + "static/media/document.8584da59.svg";